<template>
<div class="maxContainer">
  <transition name="slide-up">
  <div class="container second" @click="routeToNext" v-if="!threeShow"  @touchstart="touchstart()" @touchmove="touchmove()" @touchend="touchend()">
    <div class="mainContainer">
      <div class="maintext" v-for="(item, index) in textOne" :key="index">{{ item }}</div>
    </div>
    <div class="mainContainer mainContainer2">
      <div class="maintext" v-for="(item, index) in textTwo" :key="index">{{ item }}</div>
    </div>
    <img class="bacText" src="../assets/second_bac_text.png"/>
    <img class="seaImg" src="../assets/sea.png"/>
    <img class="iceMountain" src="../assets/ice_mountain.png" :onload="ballJump()"/>
    <img class="scollBall" src="../assets/ice_mountain_ball.gif" v-if="scollBallshow && !ballshow"/>
    <img class="smallBall" src="../assets/small_ball.png" v-if="ballshow"/>
    <img class="arrowImg" src="../assets/arrow_img.png" v-if="arrowShow"/>
    <div class="rightContainer">
      <div class="heng" ref="heng" v-for="(item, index) in hengLine" :key="index"></div>
      <img class="shuLine" ref="shuLine" src="../assets/shu_line.png"/>
      <img class="writeBall1" src="../assets/write_ball.png"/>
      <img class="writeBall2" src="../assets/write_ball.png"/>
      <img class="writeBall3" src="../assets/write_ball.png"/>
    </div>
  </div>
  </transition>
  <three-page v-if="threeShow"></three-page>
  <button class="skipBtn" @click="routeToGaokao" v-if="skipBtnShow"></button>
</div>
</template>
<script>
import threePage from './threePage'
export default {
  components: {
    threePage: threePage
  },
  data () {
    return {
      textOne: [],
      textTwo: [],
      ballshow: false,
      scollBallshow: false,
      hengLine: [0,1,2,3,4],
      threeShow: false, //是否下一页
      startY : 0,
      touching: false,
      skipBtnShow: false,
      arrowShow: false
    }
  },
  mounted () {
    setTimeout(() => {
      this.skipBtnShow = true
    }, 3000)
    this.textOneIn()
    this.textTwoIn()
    this.hengShow()
  },
  methods: {
    textOneIn () {
      let text=[
        'hey，陌生人',
        '每个人一生都在攀登',
        '在人生山丘见到你真开心',
      ]
      for(let i = 0; i < text.length; i++){
        setTimeout(()=>{
          this.textOne.push(text[i])
        }, i * 1000)
      }
    },
    textTwoIn () {
      let text=[
        '关于你的人生',
        '不同的人 有不同的建议'
      ]
      for(let i = 0; i < text.length; i++){
        setTimeout(()=>{
          this.textTwo.push(text[i])
        }, i * 1000 + 3000)
      }
      setTimeout(()=>{
        if(!this.threeShow){
          this.threeShow = true
          this.skipBtnShow = false
          setTimeout(() => {
            this.skipBtnShow = true
          }, 2000)
        }
      }, 6 * 1000 + 3000)
    },
    routeToNext () {
      setTimeout(() => {
        if(!this.threeShow){
          this.threeShow = true
          this.skipBtnShow = false
          setTimeout(() => {
            this.skipBtnShow = true
          }, 2000)
        }
      }, 1000)
    },
    ballJump () {
      setTimeout(() => {
        this.scollBallshow = true
      }, 2000)
      setTimeout(() => {
        this.ballshow = true
      }, 4000)
      setTimeout(() => {
        this.arrowShow = true
      }, 5000)
    },
    hengShow () {
      for(let i = 4; i >= 0; i--){
        setTimeout(()=>{
          this.$refs.heng[i].style.visibility = 'visible'
        }, (4-i) * 500)
      }
    },
    touchstart(e) {
      e = e || event
      if(!this.touching){
        this.startY = e.touches[0].pageY
        this.touching = true
      }
    },
    touchmove(e) {
      e = e || event
      e.preventDefault()
    },
    touchend (e) {
      e = e || event
      if(this.touching){
        this.touching = false
        let endY = e.changedTouches[0].pageY
        if(endY < this.startY){
          if(!this.threeShow){
            this.threeShow = true
            this.skipBtnShow = false
            setTimeout(() => {
              this.skipBtnShow = true
            }, 2000)
          }
        }
      }
    },
    routeToGaokao () {
      this.$router.replace({path:'/gaokao'});
    }
  }
}
</script>
<style scoped>
.maxContainer{
  height: 100%;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
}
.container{
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f3ebe2;
  padding-top: 1.8rem;
  box-sizing: border-box;
  margin: 0 auto;
  overflow: hidden;
}
.slide-up-leave-active {
  animation: conUp 2s;
}
@keyframes conUp {
  0% {transform: translateY(0);}
  100% {transform: translateY(-100%);}
}
.mainContainer{
  width: 7.5rem;
  margin: 0.7rem auto 0;
}
.mainContainer2{
  margin-top: 1rem;
}
.maintext{
  font-size: 0.3rem;
  line-height: 0.5rem;
  width: 4.14rem;
  margin: 0 auto;
  letter-spacing: 0.02rem;
  animation: fadein 1s;
  color: #504e4a;
}
@keyframes fadein{
  0% {opacity: 0;}
  100% {opacity: 1;}
}
.bacText{
  position: absolute;
  left: 0.68rem;
  top: 0.68rem;
  width: 0.13rem;
  height: 3.55rem;
}
.seaImg{
  width: 100%;
  height: 1.33rem;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 10;
}
.iceMountain{
  width: 7.8rem;
  height: 1.99rem;
  position: absolute;
  bottom: 1.28rem;
  left: 50%;
  transform: translateX(-3.75rem);
  animation: riseUp 2s linear;
}
@keyframes riseUp{
  from {bottom: -0.63rem;}
  to {bottom: 1.28rem;}
}
.smallBall{
  width: 0.3rem;
  height: 0.3rem;
  position: absolute;
  bottom: 3.23rem;
  left: 50%;
  transform: translateX(1.25rem);
  animation: jumpUp 2s ease 1s 2;
}
@keyframes jumpUp{
  0% {bottom: 3.23rem;}
  50% {bottom: 3.6rem;}
  100% {bottom: 3.23rem;}
}
.rightContainer{
  position: absolute;
  right: 0;
  top: 0rem;
  overflow: hidden;
  width: 1rem;
  height: 11.01rem;
}
.heng{
  width: 1rem;
  height: 1.5rem;
  border-bottom: 0.02rem solid #504e4a;
  margin-bottom: 0.35rem;
  visibility: hidden;
}
.shuLine{
  width: 0.23rem;
  height: 11.01rem;
  position: absolute;
  top: 0.34rem;
  right: 0.33rem;
  animation: lineRise 2s linear;
}
@keyframes lineRise{
  from {top: 11.01rem;}
  to {top: 0.34rem;}
}
.writeBall1{
  width: 0.49rem;
  height: 0.49rem;
  border-radius: 50%;
  position: absolute;
  top: 1.25rem;
  right: 0.25rem;
  animation: beBigger 0.5s 2s;
  animation-fill-mode:forwards;
  transform: scale(0.3);
  opacity: 0;
}
.writeBall2{
  width: 0.49rem;
  height: 0.49rem;
  border-radius: 50%;
  position: absolute;
  top: 3.1rem;
  right: -0.24rem;
  animation: beBigger 0.5s 2s;
  animation-fill-mode:forwards;
  transform: scale(0.3);
  opacity: 0;
}
.writeBall3{
  width: 0.94rem;
  height: 0.94rem;
  border-radius: 50%;
  position: absolute;
  top: 4.8rem;
  right: -0.2rem;
  animation: beBigger 0.5s 2s;
  animation-fill-mode:forwards;
  transform: scale(0.3);
  opacity: 0;
}
@keyframes beBigger {
  0% {transform: scale(0.3);opacity: 0;}
  100% {transform: scale(1);opacity: 1;}
}
.scollBall{
  width: 15rem;
  height: 23.58rem;
  position: absolute;
  bottom: -10.15rem;
  left: 50%;
  transform: translateX(-3.85rem);
}
.skipBtn{
  border: none;
  appearance: none;
  padding: 0;
  position: absolute;
  width: 1rem;
  height: 0.42rem;
  background: url(../assets/gotoGaokao.png);
  background-size: 100% 100%;
  top: 0.5rem;
  left: 50%;
  transform: translateX(1.8rem);
}
.arrowImg{
  width: 0.47rem;
  height: 0.52rem;
  position: absolute;
  top: 8rem;
  right: 1.5rem;
  animation: arrowToBottom 0.5s infinite alternate;
}
@keyframes arrowToBottom {
  0% {top: 8rem;}
  100% {top: 8.3rem;}
}
</style>
